import React from 'react';
import { FormLabel, Input, FormControl, FormErrorMessage } from '@chakra-ui/react';
import { useField } from 'formik';

const TextField = ({ label, ...props }) => {
    const [field, meta] = useField(props);
    return (
        <FormControl isInvalid={meta.touched && !!meta.error} mb={4}>
            <FormLabel>{label}</FormLabel>
            <Input {...field} {...props} />
            <FormErrorMessage>{meta.error}</FormErrorMessage>
        </FormControl>
    );
};

export default function AddressInput({ name = 'Address', showFirstAddress = false, label = '' }) {
    return (
        <React.Fragment>
            {
                showFirstAddress && <TextField name={'Address1.Address'} label="Address Line 1" />
            }
            <TextField name={name + '.Address'} label={showFirstAddress ? 'Address Line 2' : label || 'Address'} />
            <TextField name={name + '.City'} label="City" />
            <TextField name={name + '.State'} label="State" />
            <TextField name={name + '.Zipcode'} label="Zipcode" />
            <TextField name={name + '.Country'} label="Country" />
        </React.Fragment>
    );
}
